var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 620.000000 640.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,640.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2970 5874 c-557 -68 -973 -231 -1392 -547 -510 -383 -888 -980 -1017 -1602 -57 -278 -72 -637 -37 -893 83 -618 339 -1143 766 -1573 233 -235 442 -385 735 -529 261 -129 521 -211 805 -255 143 -23 496 -31 646 -15 659 67 1240 347 1695 817 409 423 658 933 745 1528 27 183 25 562 -5 754 -76 497 -288 971 -599 1341 -432 515 -1027 851 -1692 956 -101 15 -562 28 -650 18z m-30 -1264 l0 -250 120 0 120 0 0 250 0 250 150 0 150 0 2 -257 3 -257 99 -13 c259 -32 467 -134 554 -270 56 -88 75 -164 76 -298 1 -129 -12 -187 -61 -271 -28 -49 -116 -134 -163 -159 l-34 -18 75 -26 c188 -66 296 -172 345 -336 26 -87 24 -291 -5 -398 -75 -284 -277 -435 -654 -491 -56 -8 -132 -18 -169 -21 l-68 -7 0 -249 0 -249 -150 0 -150 0 0 245 0 245 -89 0 c-49 0 -103 3 -120 6 l-31 7 0 -252 0 -251 -165 0 -165 0 0 249 0 249 -32 6 c-24 5 -520 19 -569 16 -3 0 8 82 25 182 l31 183 147 5 c124 4 150 8 165 23 17 17 18 62 21 734 2 707 2 716 -18 759 -34 69 -77 84 -238 84 l-133 0 3 158 3 157 225 -3 c124 -2 258 0 298 3 l72 7 0 254 0 254 165 0 165 0 0 -250z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2940 3697 l0 -305 53 -4 c149 -11 402 20 482 60 117 58 168 130 168 241 0 114 -48 193 -147 241 -103 50 -164 61 -368 67 l-188 6 0 -306z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2940 2748 l0 -335 73 -7 c92 -8 328 8 431 29 231 48 341 148 340 310 0 117 -61 208 -175 259 -120 55 -196 68 -441 73 l-228 6 0 -335z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.351830661dacd41e93db18ff50cda87d.svg";
export { ForwardRef as ReactComponent };